import Filter from './src/filter-combined';
export default Filter;